__turbopack_context__.v({
  "content": "oxlm1a_content",
  "full": "oxlm1a_full",
  "wide": "oxlm1a_wide",
});
